import React from 'react';
import CardBlockView from '../Blocks/CardBlock/View';
import type { CardBlockData } from '../Blocks/CardBlock';

interface CardBlockGridItemProps {
  item: CardBlockData;
  className?: string;
  [key: string]: any;
}

const CardBlockGridItem: React.FC<CardBlockGridItemProps> = ({ item }) => {
  return (
    <div>
      <CardBlockView data={item} />
    </div>
  );
};

export default CardBlockGridItem;
